export default __webpack_public_path__ + "static/media/Background.1565ef7c.png";